import ExperienceCard from "./ExperienceCard";
import { experiences } from "../../data/experienceData";

function Experience() {
  return (
    <section
      id="experience"
      className="py-20 px-6 md:px-12 lg:px-20 bg-hero-background border-l-4 border-orange-600"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-orange-600 mb-12">
          Experience
        </h2>
        <div className="space-y-8">
          {experiences.map((experience, index) => (
            <ExperienceCard key={index} experience={experience} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
